<div class="row">
  <div class="col-md-6">
    <div class="card shadow-sm card-body">
      <form
        #niopdcFile="ngForm"
        class="form-horizontal"
        (submit)="uploadDocument()">
        <div class="form-group row">
          <label
            for="uploadNIOPDCFile"
            class="col-form-label ">
            NIOPDC File
          </label>
          <app-material-file-uploader
            [accept]="'.xls,.xlsx'"
            name="uploadNIOPDCFile"
            [(ngModel)]="currentFiles"
            required>
          </app-material-file-uploader>
        </div>
        <div class="form-group row">
          <app-material-organisation-selector
            class="pg-component"
            [(ngModel)]="company"
            [organisationLanguage]="'fa'"
            name="organisation"
            [organisations]="organisations"
            [placeholder]="'Company'"
            required>
          </app-material-organisation-selector>
        </div>
        <div class="form-group row">
          <app-material-pg-input
              label="Price(IRR)"
              type="number"
              name="lpgPrice"
              id="lpgPrice"
              [(ngModel)]="lpgPrice"
              required>
          </app-material-pg-input>
        </div>
        <div class="form-group row">
          <div class="col-md-12">
            <button
              mat-raised-button
              mat-stroked-button
              class="pull-right"
              type="submit"
              id="uploadDocument"
              value="Upload"
              [disabled]="!niopdcFile.form.valid">
              Upload
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="card shadow-sm card-body">
      <form
        #quotaFile="ngForm"
        class="form-horizontal"
        (submit)="uploadQuotaDocument()">
        <div class="form-group row">
          <label
            for="uploadQuotaFile"
            class="col-form-label ">
            Quota File
          </label>
          <app-material-file-uploader
            [accept]="'.xlsx'"
            name="uploadQuotaFile"
            [(ngModel)]="currentQuotaFiles"
            required>
          </app-material-file-uploader>
        </div>
        <div class="form-group row">
          <div class="col-md-12">
            <button
              mat-raised-button
              mat-stroked-button
              type="submit"
              id="uploadQuotaDocument"
              class="pull-right"
              value="Upload"
              [disabled]="!quotaFile.form.valid">
              Upload
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="card shadow-sm card-body">
      <form
        #paymentFile="ngForm"
        class="form-horizontal"
        (submit)="uploadPaymentDocument()">
        <div class="form-group row">
          <label
            for="uploadPaymentFile"
            class="col-form-label ">
            Payment File
          </label>
          <app-material-file-uploader
            [accept]="'.xlsx'"
            name="uploadPaymentFile"
            [(ngModel)]="currentPaymentFiles">
          </app-material-file-uploader>
        </div>
        <div class="form-group row">
          <app-material-organisation-selector
            class="pg-component"
            [(ngModel)]="companyForPayment"
            [organisationLanguage]="'fa'"
            name="organisationforPayment"
            [organisations]="organisations"
            [placeholder]="'Company'"
            required>
          </app-material-organisation-selector>
        </div>
        <div class="form-group row">
          <app-material-pg-input
              label="Price(IRR)"
              type="number"
              name="lpgPricePayment"
              id="lpgPricePayment"
              [(ngModel)]="lpgPriceForPayment"
              required>
          </app-material-pg-input>
        </div>
        <div class="form-group row">
          <div class="col-md-12">
            <button
              mat-raised-button
              mat-stroked-button
              type="submit"
              id="uploadPaymentDocument"
              class="pull-right"
              value="Upload"
              [disabled]="!paymentFile.form.valid">
              Upload
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>